import React from 'react';
import { Image, Button } from 'elements';
import strings from '../../../../utils/translationStrings';

import './PromoSection.scss';

export const PromoSection = () => {
  return (
    <section id="promo" className="promo">
      <div className="promo__container">
        <div className="promo__container--left">
          <Image
            source="/resources/images/assets/laptop.png"
            height="272px"
            width="468px"
          />
        </div>
        <div className="promo__container--right">
          <p>{strings.landing.promo.text}</p>
          <Button
            action={() => window.location.replace(`${process.env.REACT_APP_DASHBOARD_URL}/auth/sign-up`)}
            title={strings.landing.promo.button}
          />
        </div>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Landing/Partial/PromoSection/PromoSection.js